import { Box, Button, type ButtonProps } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onClick: () => void;
	title?: string;
} & ButtonProps;

export const FooterButton = ({ onClick, title, ...rest }: Props) => {
	const { t } = useResource();
	return (
		<Box
			component="footer"
			sx={{
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				px: 1.6,
				pb: 1.6,
				backgroundColor: "background.default",
				zIndex: 1000,
			}}
		>
			<Button
				variant="contained"
				color="primary"
				fullWidth
				onClick={onClick}
				{...rest}
			>
				{title ?? t(Resources.Common.continue)}
			</Button>
		</Box>
	);
};
